
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type DifferentialBrandSelectionDialogRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function DifferentialBrandSelectionDialogRT(): TemplateResult<DifferentialBrandSelectionDialogRTRootProps> {
    return _createElement('div', { 'className': 'dialog-container' }, _createElement('div', { 'className': 'dialog-content' }, _createElement('div', { 'className': 'dialog-header' }, _createElement('div', { 'className': 'dialog-title' }, 'Shop By Diff'), _createElement('div', { 'className': 'dialog-subtitle' }, 'Select the brand you want to search parts for'), _createElement('div', {
        'className': 'close',
        'data-cm-role': 'close'
    }, _createElement('svg', {
        'width': '26',
        'height': '26',
        'viewBox': '0 0 26 26',
        'fill': 'none',
        'xmlns': 'http://www.w3.org/2000/svg'
    }, _createElement('path', {
        'd': 'M5.00005 5L21.0001 21M21.0001 5L14.7778 11.2222M11.2222 14.7778L5 21.0001',
        'stroke': '#231F20',
        'strokeWidth': '1.5',
        'strokeLinecap': 'round'
    })))), _createElement('div', { 'className': 'dialog-body' }, [this.DifferentialBrandSelectionRequestPanel(function () {
            function repeatSelects1(selects, selectsIndex) {
                return [selects(function () {
                        function onError1(entry, index, e) {
                            e.target.classList.add('cm_hide');
                        }
                        function repeatEntry2(entry, index) {
                            return _createElement('div', {
                                'className': 'option' + (this.isSearchable && this.activeIndex === index || !this.isSearchable && entry.selected ? ' cm_checked' : ''),
                                'key': entry.value,
                                'onClick': () => window.Convermax.handleDifferentialBrandSelection(this, entry)
                            }, this.showCheckboxes ? _createElement('input', {
                                'type': 'checkbox',
                                'readOnly': true,
                                'checked': entry.selected,
                                'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                                'key': '678'
                            }) : null, _createElement('img', {
                                'className': 'cm_dropdown_image',
                                'src': `/cdn/shop/files/mega-menu-${ entry.value.toLowerCase() }.png`,
                                'alt': entry.value + ' image',
                                'onError': onError1.bind(this, entry, index)
                            }), _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value));
                        }
                        return _createElement('div', { 'className': this.extraClassName }, _createElement.apply(this, [
                            'div',
                            {
                                'className': 'cm_dropdown cm_select_dropdown',
                                'aria-label': this.title
                            },
                            this.loading ? _createElement('div', {
                                'className': 'option',
                                'key': 'null-option',
                                'disabled': true
                            }, '\n                    ', _translate(`select_loading`), '\n                  ') : null,
                            !this.loading ? _map(this.entries, repeatEntry2.bind(this)) : null
                        ]));
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_vehicle-widget cm_vehicle-widget__dialog cm_vehicle-widget__differential cm_vehicle-widget__differential-brand cm_DifferentialBrandSelectionRequestPanel' }, _createElement('div', { 'className': 'cm_vehicle-widget_dropdowns' }, _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement.apply(this, [
                'div',
                { 'className': 'cm_vehicle-widget_select-container  cmRepeater_selects' },
                _map(this.selects, repeatSelects1.bind(this))
            ]))));
        }, {
            widgetName: 'undefined',
            items: undefined
        })])));
}
        export const componentNames = ["cm:DifferentialBrandSelectionRequestPanel"]